module.exports = __webpack_public_path__ + "static/media/Lovers Quarrel.625180bd.otf";